import React from 'react';
// import rccarImage from '../assests/rccar.jpeg' // Assuming you have an image file
import rccarVideo from '../assests/rccar.mp4'
import dashboardImage from '../assests/dashboard.jpeg'
import tarmo_build from '../assests/tarmo_build.jpeg'
import tarmo_fresh from '../assests/tarmo_fresh.jpeg'
import tarmo_drive from '../assests/tarmo_drive.mp4'
import opencv from '../assests/opencv.mp4'
import opencv_contour from '../assests/opencv_contour.jpeg'
import opencv_servo from '../assests/opencv_servo.mp4'
import tx2_test from '../assests/tx2_test.mp4'
import line_following_steering from '../assests/line_following_steering.mp4'
import microros from '../assests/microros.mp4'
import sim_driving from '../assests/sim_driving.mp4'
import sim_steering from '../assests/sim_steering.mp4'
import pwm_signal from '../assests/pwm_signal.mp4'
import buck_converter_back from '../assests/buck_converter_back.jpeg'
import buck_converter_front from '../assests/buck_converter_front.jpeg'
import platform_v1 from '../assests/platform_v1.jpeg'
import platform_v2 from '../assests/platform_v2.jpeg'
import platform_v3 from '../assests/platform_v3.jpeg'
import platform_v4 from '../assests/platform_v4.jpeg'


const AutonomousRCCar = () => {
  return (
    <div className="w-full min-h-screen text-blue-light bg-gray-100 pt-[120px]">
      <div className="max-w-[900px] mx-auto p-8 flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <h1 className="text-4xl font-bold inline border-b-4 border-blue-dark text-blue-dark">
            Autonomous RC Car
          </h1>
          <p className="py-6 text-gray-700">
            A look into the development of my Autonomous RC Car project.
          </p>
        </div>
        
        <div className="mb-8">
          <h2 className="text-2xl font-semibold text-blue-dark border-b-2">Motivation</h2>
          <p className="py-4 text-gray-600">
            Testing my code for the driverless section of the Formula Racing Team at the University of Toronto heavily relied on simulation through RViz.
            I was, however, much more interested in real world feedback of a project, which led to the start of this one.
            My goal was to set up a RC car that could run code that a friend and I wrote for the Design Team at the University.
            Along the way I would learn ROS2 from the ground up, not just using it as a tool, which I recognized would be important for future projects in robotics at the Univeristy.
          </p>
          {/* <div
            style={{ backgroundImage: `url(${rccarImage})` }}
            className="w-full h-80 bg-cover bg-center rounded shadow-lg mb-6"
          /> */}
        </div>
        
        <div className="mb-8">
          <h2 className="text-2xl font-semibold text-blue-dark border-b-2">Process</h2>
          
          <p className="py-4 text-gray-600"> </p>

          <h2 className="text-2xl  text-blue-dark">3D Printed RC Car</h2>
          <p className="py-4 text-gray-600">
            The first step in the project was to create the hardware (i.e. RC car) for other parts to take shape.
            This was also an opportunity to explore the world of 3D printing, as the cost of RC car kits are steep.
            Tarmo5 was the chosen starting point.
          </p>

          <div className="mb-8 flex flex-col md:flex-row items-center justify-center gap-8">
            {/* Text/Image Section */}
            <div className="w-full h-64 md:w-1/4 text-gray-600 shadow-lg">
                {/* <h2 className="text-2xl font-semibold text-blue-dark">Development Process</h2> */}
                {/* <p className="py-4"> Our development process involved several  </p> */}
                <div
                style={{ backgroundImage: `url(${tarmo_build})` }}
                className="w-full h-full bg-cover bg-center rounded"
                />
            </div>

            {/* Text/Image Section */}
            <div className="w-full h-64 md:w-6/12 text-gray-600 shadow-lg">
                {/* <h2 className="text-2xl font-semibold text-blue-dark">Development Process</h2> */}
                {/* <p className="py-4"> Our development process involved several  </p> */}
                <div
                style={{ backgroundImage: `url(${tarmo_fresh})` }}
                className="w-full h-full bg-cover bg-center rounded"
                />
            </div>

            {/* Video */}
            <div className="w-full md:w-auto h-64 rounded shadow-lg flex justify-center">
                <video
                className="h-full object-contain rounded"
                controls
                >
                <source src={tarmo_drive} type="video/mp4" />
                Your browser does not support the video tag.
                </video>
            </div>
          </div>
          
          <h2 className="text-2xl  text-blue-dark">Controlling Hardware</h2>
          <p className="py-4 text-gray-600">
            The next step was to be able to control the RC car with hardware instead of the radio controllers.
            An ESP32 was chosen for its cost and its versatility with wirless communication, leaving the options open should they be needed.
            The first step was to be able to read PWM signals from the radio controller and send my own PWM signals with an ESP32.
            While this chapter was successful, it turned out that ROS2 would be beneficial, as suggested by the software lead at RoboSoccer.
            However, this still gave me exposure to the ESP-IDF framework in C++.
          </p>
          <div className="mb-8 flex flex-col md:flex-row items-center justify-center gap-8">
            {/* Video */}
            <div className="w-full md:w-auto h-80 rounded shadow-lg flex justify-center">
                <video
                className="h-full object-contain rounded"
                controls
                >
                <source src={pwm_signal} type="video/mp4" />
                Your browser does not support the video tag.
                </video>
            </div>

            {/* Text/Image Section */}
            <div className="w-full h-80 md:w-1/3 text-gray-600 shadow-lg">
                {/* <h2 className="text-2xl font-semibold text-blue-dark">Development Process</h2> */}
                {/* <p className="py-4"> Our development process involved several  </p> */}
                <div
                style={{ backgroundImage: `url(${buck_converter_front})` }}
                className="w-full h-full bg-cover bg-center rounded"
                />
            </div>

            {/* Text/Image Section */}
            <div className="w-full h-80 md:w-1/3 text-gray-600 shadow-lg">
                {/* <h2 className="text-2xl font-semibold text-blue-dark">Development Process</h2> */}
                {/* <p className="py-4"> Our development process involved several  </p> */}
                <div
                style={{ backgroundImage: `url(${buck_converter_back})` }}
                className="w-full h-full bg-cover bg-center rounded"
                />
            </div>
          </div>

          <h2 className="text-2xl  text-blue-dark">Learning ROS2</h2>
          <p className="py-4 text-gray-600">
            With only surface level experience from using ROS and ROS2 from Design Teams,
            creating a project from end-to-end would require understanding from the ground up,
            which is exactly what I was looking for.
            With tutorials online, I started my journey with a simulation environment.
          </p>

          <h2 className="text-2xl  text-blue-dark">Creating Sim Environment</h2>
          <div className="mb-8 flex flex-col md:flex-row items-center justify-center gap-8">
            {/* Text/Image Section */}
            <div className="w-full h-96 md:w-7/12 text-gray-600">
                {/* <h2 className="text-2xl font-semibold text-blue-dark">Development Process</h2> */}
                <p className="py-4 text-gray-600"> 
                The simulation using RViz and Gazebo gave me an overview to ROS2 protocols (e.g. topics, nodes, publishing, and subscribing).
                However, after giving my URDF model camera capabilities, I realized it would be slightly difficult
                to include odometry, given that the motor has no encoders nor do I have any hall sensors built into the RC car. 
                However, I still learned a lot of the fundametals from this process, creating packages, publishers, and subscribers for example.
                </p>
            </div>

            {/* Video */}
            <div className="w-full md:w-4/12 h-80 rounded shadow-lg flex justify-center">
                <video
                className="h-full object-contain rounded"
                controls
                >
                <source src={sim_steering} type="video/mp4" />
                Your browser does not support the video tag.
                </video>
            </div>
            <div className="w-full md:w-4/12 h-80 rounded shadow-lg flex justify-center">
                <video
                className="h-full object-contain rounded"
                controls
                >
                <source src={sim_driving} type="video/mp4" />
                Your browser does not support the video tag.
                </video>
            </div>
          </div>

          <h2 className="text-2xl  text-blue-dark">Using MicroROS</h2>
          <p className="py-4 text-gray-600">
            After the realization above, my next target was to begin integrating ROS2 into my RC car hardware.
            With the previous experience using ESP32, I found that they had MicroROS capabilities that I would
            be able to take advantage of, since I had an Nvidia Jetson TX2, that would enable on-board processing.
            First, was to be able to control 2 servos using MicroROS.
          </p>
          
          <div className="mb-8 flex flex-col md:flex-row items-center justify-center gap-8">
            {/* Video */}
            <div className="w-full md:w-auto h-64 rounded shadow-lg flex justify-center">
                <video
                className="h-full object-contain rounded"
                controls
                >
                <source src={microros} type="video/mp4" />
                Your browser does not support the video tag.
                </video>
            </div>
          </div>

          <h2 className="text-2xl  text-blue-dark">Camera Integration with ROS2</h2>
          <p className="py-4 text-gray-600">
            Through research online, v4l2 looked to be the camera package for Nvidia Jetsons, which allowed me to
            read data from ROS2 topic of camera_raw. 
          </p>

          <h2 className="text-2xl  text-blue-dark">Video Processing using OpenCV</h2>
          <p className="py-4 text-gray-600">
            Currently, OpenCV allows...
          </p>

          <div className="mb-8 flex flex-col md:flex-row items-center justify-center gap-8">

            {/* Video */}
            <div className="w-full md:w-auto h-64 rounded shadow-lg flex justify-center">
                <video
                className="h-full object-contain rounded"
                controls
                >
                <source src={opencv} type="video/mp4" />
                Your browser does not support the video tag.
                </video>
            </div>

            {/* Text/Image Section */}
            <div className="w-full h-64 md:w-5/12 text-gray-600 shadow-lg">
                <div
                style={{ backgroundImage: `url(${opencv_contour})` }}
                className="w-full h-full bg-cover bg-center rounded"
                />
            </div>
          </div>


          <h2 className="text-2xl  text-blue-dark">Running on TX2</h2>
          {/* <p className="py-4 text-gray-600">
            While every component would work on the dev machine, porting the workspace to the tx2 was not so straight forward.
            This gave me exposure to using Docker, which ensured that I was able to run ROS2 foxy on the TX2 running some version of JetPack with Ubuntu 18.
          </p> */}

          <div className="mb-8 flex flex-col md:flex-row  gap-8">
            {/* Text/Image Section */}
            <div className="w-full h-96 md:w-7/12 text-gray-600">
                {/* <h2 className="text-2xl font-semibold text-blue-dark">Development Process</h2> */}
                <p className="py-4 text-gray-600"> 
                While every component would work on the dev machine, porting the workspace to the tx2 was not so straight forward.
                This gave me exposure to using Docker, which ensured that I was able to run ROS2 foxy on the TX2 running some version of JetPack with Ubuntu 18.  
                </p>

                <p className="py-4 text-gray-600"> 
                    The video processing would control the steering of the depending on how off center the line was from the center of
                    the screen.
                </p>
            </div>

            {/* Video */}
            <div className="w-full md:w-4/12 h-96 rounded shadow-lg flex justify-center">
                <video
                className="h-full object-contain rounded"
                controls
                >
                <source src={tx2_test} type="video/mp4" />
                Your browser does not support the video tag.
                </video>
            </div>

            {/* Video */}
            <div className="w-full md:w-4/12 h-96 rounded shadow-lg flex justify-center">
                <video
                className="h-full object-contain rounded"
                controls
                >
                <source src={opencv_servo} type="video/mp4" />
                Your browser does not support the video tag.
                </video>
            </div>
          </div>

          <h2 className="text-2xl  text-blue-dark">Designing Autonomous Platform</h2>
          <p className="py-4 text-gray-600">
            Collage of the different itterations of the autonomous platfrom to hold camera, tx2, and battery.
            Used CAD to 3D print the designs and put on stand-offs to separate other components. 
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div
              style={{ backgroundImage: `url(${platform_v1})` }}
              className="w-full h-80 bg-cover bg-center rounded shadow-lg"
            />
            <div
              style={{ backgroundImage: `url(${platform_v2})` }}
              className="w-full h-80 bg-cover bg-center rounded shadow-lg"
            />
            <div
              style={{ backgroundImage: `url(${platform_v3})` }}
              className="w-full h-80 bg-cover bg-center rounded shadow-lg"
            />
            <div
              style={{ backgroundImage: `url(${platform_v4})` }}
              className="w-full h-80 bg-cover bg-center rounded shadow-lg"
            />
          </div>
        </div>

        <div className="mb-8">
          <h2 className="text-2xl  text-blue-dark">Testing Line Following</h2>
          <p className="py-4 text-gray-600">
            With everything set up, all that was left was to run the code.
            This included running the following ROS2 topics:
          </p>
          <ul className="list-disc list-inside text-gray-600">
            <li className="py-2">v4l2 for camera (TX2)</li>
            <li className="py-2">MicroROS agent (TX2)</li>
            <li className="py-2">line follower package (Dev Machine)</li>
          </ul>
          <div className="mb-8 flex flex-col md:flex-row items-center justify-center gap-8">
            {/* Video */}
            <div className="w-full md:w-auto h-80 rounded shadow-lg flex justify-center">
                <video
                className="h-full object-contain rounded"
                controls
                >
                <source src={line_following_steering} type="video/mp4" />
                Your browser does not support the video tag.
                </video>
            </div>

            {/* Video */}
            <div className="w-full md:w-auto h-80 rounded shadow-lg flex justify-center">
                <video
                className="h-full object-contain rounded"
                controls
                >
                <source src={rccarVideo} type="video/mp4" />
                Your browser does not support the video tag.
                </video>
            </div>

            {/* Text/Image Section */}
            <div className="w-full h-80 md:w-1/2 text-gray-600 shadow-lg">
                {/* <h2 className="text-2xl font-semibold text-blue-dark">Development Process</h2> */}
                {/* <p className="py-4"> Our development process involved several  </p> */}
                <div
                style={{ backgroundImage: `url(${dashboardImage})` }}
                className="w-full h-full bg-cover bg-center rounded"
                />
            </div>
          </div>


        </div>
        
        <div className="mb-8">
          <h2 className="text-2xl font-semibold text-blue-dark">Improvements (Coming Sep.)</h2>
          <p className="py-4 text-gray-600">
            Currently, its simply OpenCV masking and I would like to incorrporate ML.
            Onboard processing will be required due to the latency experienced with the video feed.
          </p>
        </div>
        
        {/* <div className="mb-8">
          <h2 className="text-2xl font-semibold text-blue-dark">Gallery</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div
              style={{ backgroundImage: `url(${rccarImage})` }}
              className="w-full h-80 bg-cover bg-center rounded shadow-lg"
            />
            <div
              style={{ backgroundImage: `url(${rccarImage})` }}
              className="w-full h-80 bg-cover bg-center rounded shadow-lg"
            />
            <div
              style={{ backgroundImage: `url(${rccarImage})` }}
              className="w-full h-80 bg-cover bg-center rounded shadow-lg"
            />
            <div
              style={{ backgroundImage: `url(${rccarImage})` }}
              className="w-full h-80 bg-cover bg-center rounded shadow-lg"
            />
          </div>
        </div> */}
        
        <div className="mb-8">
          <h2 className="text-2xl font-semibold text-blue-dark">Conclusion</h2>
          <p className="py-4 text-gray-600">
            The Autonomous RC Car project has been a self-motivated project that has had its difficulties,
            times where the project seems insurmountable as I had no clue where to start, other times when parts started working 
            I would run into other issues. Keeping my mind flexible to these circumstances, allowed me to
            reiterate the design, which slowly made the path to the final product more clear.
            Ultimately, proud of the current state, but eagar to include improvements.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AutonomousRCCar;
